import React from 'react';
import { connect } from 'react-redux';
import Popover from '../../components/uielements/popover';
import IntlMessages from '../../components/utility/intlMessages';
import userpic from '../../image/image-placeholder.png';
import authAction from '../../redux/auth/actions';
import TopbarDropdownWrapper from './topbarDropdown.style';
import Amplify, { API, Auth, graphqlOperation, Storage } from 'aws-amplify';
import { AuthPiece } from 'aws-amplify-react';
import { Link } from 'react-router-dom';
import { Icon, Modal, Tooltip } from 'antd';
import { getTherapistProfile, LogUserAuthEvent } from '../../graphql/queries';
import graphql_endpoint from '../../aws-appsync-url';
import { store } from '../../redux/store';
import WelcomeModal from '../../components/welcomeModal';
import fetchUrl from '../../helpers/fetchUrl';
import clientActions from '../../redux/module/client/actions';
import { helpConfig, videoConfig } from '../../helpers/helpCofig';
import { getTeamMemberList } from '../../helpers/helper';

const {
resetData
} = clientActions;

const { logout } = authAction;

class TopbarUser extends AuthPiece {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      profileImage: userpic,
      showTour: false
    };
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
  }
  componentDidMount(){
    this.getImage();
    window.addEventListener('keydown', (e) =>{
      if(e.key ==='Escape'||e.key ==='Esc'||e.keyCode === 27){
        // e.preventDefault();
        if(this.state.helpVideo) {
          this.setState({
            helpVideo: '',
          });
        }
      }
    });
  }
  async getImage() {
    const members = await getTeamMemberList();
    try {
      Amplify.configure({
        API: {
          graphql_endpoint: graphql_endpoint.BTPORTAL
        }
      });

      const { data: { getTherapist } } = await API.graphql(graphqlOperation(getTherapistProfile));
      store.dispatch({ type: 'SET_DB_ID', payload: getTherapist && getTherapist.id });
      if (getTherapist && getTherapist.photo && getTherapist.photo.s3path) {
        store.dispatch({ type: 'SET_S3_PHOTO', payload: getTherapist && getTherapist.photo.s3path });
        this.downloadImage(`images/all/${getTherapist.photo.s3path}`)
      }
    }catch (err) {
      console.log(err);
    }
  }
  downloadImage = async (imgPath) => {
    try {
      Storage.configure({
        AWSS3: {
          bucket: graphql_endpoint.profileImageBucket, //REQUIRED -  Amazon S3 bucket
          region: 'us-east-1', //OPTIONAL -  Amazon service region
        }});
      const profileImage = await Storage.get(imgPath, {
        customPrefix: {
          public: ''
        }
      });
      this.setState({ profileImage });
    } catch (err) {
      console.log(err);
    }
  };

  hide() {
    this.setState({ visible: false });
  }

  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }

  signout = () => {
    fetchUrl.BTPORTAL(LogUserAuthEvent,{event:'LOGOUT_SUCCESS'});
    Auth.signOut()
      .then(() => {
        store.dispatch(resetData());
        this.props.logout();
        this.props.history.push({pathname:'/signin',state: true});
      localStorage.clear();
      })
      .catch(err => { this.error(err) });
  };

  handleCancel = () => {
    this.setState({ showTour: false });
  };

  showWelcomeModal = () => {
    this.setState({ showTour: true })
  };

  showVideoModal = () =>{
    if(videoConfig[this.props.location.pathname]) {
      this.setState({
        helpVideo: videoConfig[this.props.location.pathname]
      })
    }
  };

  handleHelpClick = () =>{
    if(helpConfig[this.props.location.pathname]) {
      window.open(helpConfig[this.props.location.pathname], "_blank")
    }
  };

  render() {
    const groups = store.getState().Auth.get('groups');
    const isOnlyCoordinator = groups.length === 1 && groups.includes('coordinators');
    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown">
        {
          !isOnlyCoordinator
            ? <Link className="isoDropdownLink" to={`/app/profile`}>
              <IntlMessages id="Profile" />
            </Link>
            : null
        }

        {/*
          !isOnlyCoordinator
            ? <Link className="isoDropdownLink" to={`/app/payments`}>
              <IntlMessages id="Payments" />
            </Link>
            : null
        */}
        <a className="isoDropdownLink" onClick={this.signout}>
          <IntlMessages id="topbar.logout" />
        </a>
      </TopbarDropdownWrapper>
    );
    return (
      <div style={{ display: "inline-flex" }}>
        <Tooltip title="Help">
          <a style={{ margin: "auto" }}>
            <Icon type="question-circle" theme="filled" className="topbar-tour-icon"
                  onClick={this.handleHelpClick}
                  style={{ margin: 'auto', height: '21px', cursor: "pointer" }} />
          </a>
        </Tooltip>
        <Tooltip title="Help Video">
          <Icon type="play-square" theme="filled" className="topbar-tour-icon"
                onClick={this.showVideoModal}
                style={{ margin: 'auto 0 auto 20px', height: '21px', cursor: "pointer" }} />
        </Tooltip>
        <Tooltip title="Tour">
          <Icon type="weibo-circle" theme="filled" className="topbar-tour-icon"
                onClick={this.showWelcomeModal}
                style={{ margin: 'auto 20px', height: '21px', cursor: "pointer" }} />
        </Tooltip>
        <Popover
          content={content}
          trigger="hover"
          visible={this.state.visible}
          onVisibleChange={this.handleVisibleChange}
          arrowPointAtCenter={true}
          placement="bottomLeft"
        >
          <div className="isoImgWrapper">
            <img alt="user" src={this.state.profileImage} style={{ borderRadius: '50%' }} />
            <span className="userActivity online" />
          </div>
        </Popover>

        <Modal
          className='help-modal'
          visible={this.state.helpVideo}
          footer={null}
          onCancel={() => this.setState({
          helpVideo: ''
        })}>
          {this.state.helpVideo ?
          <iframe height="500" src="https://www.youtube.com/embed/tgbNymZ7vqY?playlist=tgbNymZ7vqY&loop=1" />
            : null}
        </Modal>
        <WelcomeModal visible={this.state.showTour} onCancel={this.handleCancel} />
      </div>
    );
  }
}
export default connect(null, { logout })(TopbarUser);
